import { Link } from 'react-router';
import { CheckCircle2Icon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import { Button } from '@/components/ui/button';

// Stripe redirects here after a successful Checkout. Webhook processing that
// flips subscription_status to "active" happens async and isn't guaranteed
// to have landed yet, so this shows a generic confirmation rather than
// polling/blocking on that field — /billing reflects the real status once it
// (re)loads.
export function BillingSuccess() {
  const { t } = useLanguage();

  return (
    <div className="max-w-md mx-auto flex flex-col items-center gap-4 text-center py-16">
      <CheckCircle2Icon className="w-12 h-12 text-green-600 dark:text-green-400" />
      <h1 className="text-xl font-semibold">{t.billingSuccessTitle}</h1>
      <p className="text-sm text-muted-foreground">{t.billingSuccessSubtitle}</p>
      <Button asChild>
        <Link to="/billing">{t.billingSuccessBackLink}</Link>
      </Button>
    </div>
  );
}
